import { Row, Col, Card, Alert } from 'antd';
import moment from 'moment';
import { ssDateUtils } from '@bit/ui-common.ui-components/ss-utils';

// https://stackoverflow.com/questions/248011/how-do-i-wrap-text-in-a-pre-tag

const { unixSecondsToTimestampString } = ssDateUtils;


class EmailHeader extends React.Component {
    constructor(props) { super(props); }

    getEntry = (name, data) => !data ? null : (
        <div>
            <Row>
                <Col span={6}>
                    <div className='ss-email-header-name'>
                        {name}
                    </div>
                </Col>
                <Col span={18}>
                    <div className='ss-email-header-data'>
                        {data}
                    </div>
                </Col>
            </Row>
        </div>
    )

    render() {
        const { email, type } = this.props;
        switch(type) {
            case 'preview': return (
                <div>
                    {this.getEntry('Email ID', email.emailId)}
                    {this.getEntry('Training Request ID', email.trId)}
                    {this.getEntry('Student Name', email.studentName)}
                    {this.getEntry('Recipients', email.recipients)}
                    {this.getEntry('Subject', email.subject)}
                    {this.getEntry('Cc', email.cc)}
                    {this.getEntry('Date Sent', !email.dateSent ? null : unixSecondsToTimestampString(email.dateSent))}
                </div>
            )

            default: return (
                <div>
                    {this.getEntry('Email ID', email.emailId)}
                    {this.getEntry('Training Request ID', email.trId)}
                    {this.getEntry('Student Name', email.studentName)}
                    {this.getEntry('Recipients', email.recipients)}
                    {this.getEntry('Subject', email.subject)}
                    {this.getEntry('Cc', email.cc)}
                    {this.getEntry('Date Sent', !email.dateSent ? null : unixSecondsToTimestampString(email.dateSent))}
                </div>
            )
        }
    }
}

export default class EmailView extends React.Component {
    constructor(props) {
        super(props);
        const { getEmailPreview, emailMap, getCaseEmail, caseGuid } = props;

        if (emailMap)
          getEmailPreview(emailMap);
        else if (caseGuid){
          getCaseEmail(caseGuid)
        }
    }

    componentDidUpdate(prevProps) {
        const
        { timeStamp } = this.props,
        lastTimeStamp = prevProps.timeStamp;

        if (timeStamp > lastTimeStamp) {
          const { getEmailPreview, emailMap, getCaseEmail, caseGuid } = this.props;

          if (emailMap)
            getEmailPreview(emailMap);
          else if (caseGuid){
            getCaseEmail(caseGuid)
          }
        }
    }

    render() {
        const
        { emailRequestState, inError, isConfirm} = this.props,
        { emailPreviewStore, loadTime } = emailRequestState;

        return (
            <div>
                <Row type='flex' justify='center' align='middle'>
                    <Col span={24}>
                        <div className='ss-email-view-card'>
                            <Card bordered={false} bodyStyle={{ padding: '0px' }} loading={emailRequestState.isLoading && !inError}>
                                <Row style={{ marginBottom: '15px' }}>
                                    <Col span={24}>
                                        {isConfirm?null:
                                        <div className='ss-email-header'>
                                            {!loadTime ? null : <EmailHeader type='preview' email={emailPreviewStore} />}
                                        </div>}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={24}>
                                        <div style={{ overflow: 'auto' }}>{
                                            inError || emailRequestState.inError || !emailPreviewStore
                                                ? <Alert message='Error generating email preview' type='error' />
                                                : !loadTime ? null : (
                                                    <pre style={{
                                                        maxHeight: '350px',
                                                        scroll: 'auto',
                                                        whiteSpace: 'pre-wrap',
                                                        whiteSpace: 'moz-pre-wrap',
                                                        whiteSpace: 'pre-wrap',
                                                        wordWrap: 'break-word'
                                                    }}>
                                                        {emailPreviewStore.content}
                                                    </pre>
                                                )
                                        }</div>
                                    </Col>
                                </Row>
                            </Card>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}
